import React from 'react'
import "./retail.scss"
import WhereYouNeed from './sections/whereYouNeed'
import DataProtection from './sections/priorityProtection'
import DataProtectionList from './sections/productPerformanceList'
import Letsgo from "../connectors/letsgo"

function DataProtectionPage() {
  return (
    <div className='container-retail'>
        <div className='section-b2c-profits'>
            <WhereYouNeed />
        </div>
        <div className="section-numerous-processes">
          <DataProtection />
        </div>
        <div className="section-product-performance-list">
          <DataProtectionList />
        </div>
        <div className="section-lets-go">
        <Letsgo />
        </div>
    </div>
  )
}

export default DataProtectionPage